import { render, staticRenderFns } from "./SectorsPage.vue?vue&type=template&id=f1c5b608&scoped=true"
import script from "./SectorsPage.vue?vue&type=script&lang=js"
export * from "./SectorsPage.vue?vue&type=script&lang=js"
import style0 from "./SectorsPage.vue?vue&type=style&index=0&id=f1c5b608&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5b608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c5b608')) {
      api.createRecord('f1c5b608', component.options)
    } else {
      api.reload('f1c5b608', component.options)
    }
    module.hot.accept("./SectorsPage.vue?vue&type=template&id=f1c5b608&scoped=true", function () {
      api.rerender('f1c5b608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/sectors/SectorsPage.vue"
export default component.exports